//////////////Running Code::::::::::::::::::::::::::

// import React, { useState, useCallback, useEffect, useRef, memo } from 'react';
// import Webcam from 'react-webcam';
// import { useDispatch, useSelector } from 'react-redux';
// import classes from './CheckIn.module.scss';
// import { checkInTime } from './../../../../Redux/action/index';
// import { closeCheckIn, closeCheckOut } from './../../../../Redux/action/interactions';
// import toast from 'react-hot-toast';


// const CheckIn = ({ loading, location, cmd }) => {
//   const videoConstraints = {
//     width: 275,
//     height: 275,
//     facingMode: 'user',
//   };

//   console.log(location.location);
//   const dispatch = useDispatch();
//   const [locData, setLocData] = useState(location);
//   const [picture, setPicture] = useState(null);
//   const [isSite, setIsSite] = useState(false);
//   const [siteLoc, setSiteLoc] = useState("");

//   const webcamRef = useRef(null);
//   const CAMERA_DISABLED = useRef(null);
//   const SITE_BLANK = useRef(null);

//   const currentDate = new Date();

//   useEffect(() => {
//     if (window.env) {
//       CAMERA_DISABLED.current = window.env.ERROR.CAMERA_DISABLED
//       SITE_BLANK.current = window.env.ERROR.SITE_BLANK
//     } else {
//       toast.error("Problem in getting ENV File");
//     }

//     const checkWebcamEnabled = async () => {
//       try {
//         // Access the webcam using the webcamRef
//         const stream = await navigator.mediaDevices.getUserMedia({ video: true });
//       } catch (error) {
//         // Webcam is not enabled
//         toast(CAMERA_DISABLED.current, {
//           icon: '❗',
//         });
//         dispatch(closeCheckIn(false))
//       }
//     };
//     checkWebcamEnabled();

//     if (locData.location === 'SITE') {
//       setIsSite(true);
//     }
    
//     // Stop the Page from remaining open for more than 1 minute
//     setTimeout(() => {window.location.reload(true);},30000);
//   }, [])
//   const handleSiteLoc = (event) => {
//     setSiteLoc(event.target.value);
//   }

//   const getDeviceInfo = () => {
//     const userAgent = navigator.userAgent;
//     const isMobile = /Mobile/i.test(userAgent);

//     if (isMobile) {
//       if (/Android/i.test(userAgent)) {
//         return "Android";
//       } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
//         return "iOS";
//       } else {
//         return "Mobile device of an unknown type";
//       }
//     } else {
//       return "Desktop";
//     }
//   }

//   const capture = () => {
//     const pictureSrc = webcamRef.current.getScreenshot();

//     if (isSite && siteLoc.trim() === "") {
//       // Display a toast message or any other feedback to indicate that the user needs to enter a location
//       toast(SITE_BLANK.current, {
//         icon: '❗',
//       });
//       return; // Exit the function without sending the photo to the server
//     }

//     sendPhotoToServer(pictureSrc.substring(23));
//     setPicture(pictureSrc);
//   }

//   const sendPhotoToServer = (imageSrc) => {
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));
//     localStorage.setItem('Photo', imageSrc);

//     if (locData.location === "SITE") {
//       dispatch(checkInTime(
//         cmd.toString(),
//         userID,
//         data.empid,
//         data.token,
//         imageSrc,
//         locData.latlong,
//         locData.location,
//         locData.distance2,
//         locData.accuracy,
//         siteLoc
//       ));
//     } else {
//       dispatch(checkInTime(
//         cmd.toString(),
//         userID,
//         data.empid,
//         data.token,
//         imageSrc,
//         locData.latlong,
//         locData.location,
//         locData.distance2,
//         locData.accuracy,
//         siteLoc
//       ));

//     }
//   }

//   const Time = () => {
//     let hours = currentDate.getHours();
//     let minutes = currentDate.getMinutes();
//     let seconds = currentDate.getSeconds();
//     seconds = seconds < 10 ? "0" + parseInt(seconds) : seconds;
//     let ampm = hours >= 12 ? 'pm' : 'am';
//     hours = hours % 12;
//     hours = hours ? hours : 12; // the hour '0' should be '12'
//     minutes = minutes < 10 ? '0' + minutes : minutes;
//     let strTime = hours + ':' + minutes + ':' + seconds + " " + ampm;
//     return strTime;
//   }

//   return (
//     <div>
//       <div className={classes.WebcamDiv}>
//         <div style={{ display: 'flex', flexDirection: "column", widrh: '100%' }}>
//           <h2> Current Location </h2>
//           <h3>{locData.location.replace(/_/g, ' ')}</h3>
          
//           {picture !== null ?
//             <img src={picture} alt="Capture" style={{ transform: "scaleX(-1)" }} />
//             :
//             <Webcam
//               audio={false}
//               ref={webcamRef}
//               screenshotFormat="image/jpeg"
//               videoConstraints={videoConstraints}
//               style={{ width: "100%", transform: "scaleX(-1)" }}
//             />}

//           {isSite && <input style={{ width: "100%", padding: "10px" }} onChange={handleSiteLoc} placeholder='Please Enter Location' />}
//           <div style={{ display: "flex" }}>
//             <button onClick={capture}>{cmd}</button>
//             <button onClick={() => { if (cmd === "CheckIn") { dispatch(closeCheckIn(false)); } else if (cmd === "CheckOut") { dispatch(closeCheckOut(false)); }; localStorage.removeItem('Photo'); }}>Close</button>
//           </div>
          
//           <div className={classes.DateTimeDiv}>

//             <div className={classes.Date}>
//               {/* Date */}
//               <h2>Date:</h2>
//               <p>
//                 {`
//                 ${String(currentDate.getDate()).padStart(2, '0')} /
//                 ${currentDate.getMonth() < 10 ? "0" + parseInt(currentDate.getMonth() + 1) : currentDate.getMonth()}
//                 / ${currentDate.getFullYear()}
//                 `}
//               </p>
//             </div>

//             <div className={classes.Time}>
//               <h2>Time:</h2>
//               {/* Time */}
//               <p>{Time()}</p>
//             </div>
//           </div>

//         </div>
//       </div>
//     </div>
//   )
// }

// export default CheckIn;






///////////////:::::::::::::::::::::::::::::::::::::
    //  /////////My_Testing Code:::::::::::::::::
// //////////////////////////::::: Adding DeviceId :::::///////////////////////////////////
 
//////// Pass the varibale of device_id into the macid...

// import React, { useState, useEffect, useRef } from 'react';
// import Webcam from 'react-webcam';
// import { useDispatch } from 'react-redux';
// import classes from './CheckIn.module.scss';
// import { checkInTime } from './../../../../Redux/action/index';
// import { closeCheckIn, closeCheckOut } from './../../../../Redux/action/interactions';
// import toast from 'react-hot-toast';
// import { v4 as uuidv4 } from 'uuid'; // Install `uuid` library

// const CheckIn = ({ loading, location, cmd }) => {
//   const videoConstraints = {
//     width: 275,
//     height: 275,
//     facingMode: 'user',
//   };

//   const dispatch = useDispatch();
//   const [locData, setLocData] = useState(location);
//   const [picture, setPicture] = useState(null);
//   const [isSite, setIsSite] = useState(false);
//   const [siteLoc, setSiteLoc] = useState('');
//   const [deviceId, setDeviceId] = useState('');   //Update this line

//   const webcamRef = useRef(null);
//   const CAMERA_DISABLED = useRef(null);
//   const SITE_BLANK = useRef(null);

//   const currentDate = new Date();

//   useEffect(() => {
//     // Initialize Error Messages
//     if (window.env) {
//       CAMERA_DISABLED.current = window.env.ERROR.CAMERA_DISABLED;
//       SITE_BLANK.current = window.env.ERROR.SITE_BLANK;
//     } else {
//       toast.error('Problem in getting ENV File');
//     }

//     // Check Webcam Permission
//     const checkWebcamEnabled = async () => {
//       try {
//         await navigator.mediaDevices.getUserMedia({ video: true });
//       } catch (error) {
//         toast(CAMERA_DISABLED.current, { icon: '❗' });
//         dispatch(closeCheckIn(false));
//       }
//     };
//     checkWebcamEnabled();

//     if (locData.location === 'SITE') {
//       setIsSite(true);
//     }

//     // Generate or Retrieve Device ID
//     const storedDeviceId = localStorage.getItem('deviceId');
//     if (!storedDeviceId) {
//       const newDeviceId = uuidv4();
//       localStorage.setItem('deviceId', newDeviceId);         //when user click checkIn then generate DeviceId.
//       setDeviceId(newDeviceId);
//     } else {
//       setDeviceId(storedDeviceId);
//     }

//     // Auto-Reload After Timeout
//     setTimeout(() => {
//       window.location.reload(true);
//     }, 30000);
//   }, []);

//   const handleSiteLoc = (event) => {
//     setSiteLoc(event.target.value);
//   };

//   const getDeviceInfo = () => {
//     const userAgent = navigator.userAgent;
//     const isMobile = /Mobile/i.test(userAgent);

//     if (isMobile) {
//       if (/Android/i.test(userAgent)) {
//         return 'Android';
//       } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
//         return 'iOS';
//       } else {
//         return 'Mobile device of an unknown type';
//       }
//     } else {
//       return 'Desktop';
//     }
//   };

//   const capture = () => {
//     const pictureSrc = webcamRef.current.getScreenshot();

//     if (isSite && siteLoc.trim() === '') {
//       toast(SITE_BLANK.current, { icon: '❗' });
//       return;
//     }

//     sendPhotoToServer(pictureSrc.substring(23));
//     setPicture(pictureSrc);
//   };

//   const sendPhotoToServer = (imageSrc) => {
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));
//     localStorage.setItem('Photo', imageSrc);

//     dispatch(
//       checkInTime(
//         cmd.toString(),
//         userID,
//         data.empid,
//         data.token,
//         imageSrc,
//         locData.latlong,
//         locData.location,
//         locData.distance2,
//         locData.accuracy,
//         siteLoc,
//         deviceId, // Send device ID as part of payload
//         mac_id
//       )
//     );
//   };

//   const Time = () => {
//     let hours = currentDate.getHours();
//     let minutes = currentDate.getMinutes();
//     let seconds = currentDate.getSeconds();
//     seconds = seconds < 10 ? '0' + parseInt(seconds) : seconds;
//     let ampm = hours >= 12 ? 'pm' : 'am';
//     hours = hours % 12;
//     hours = hours ? hours : 12; // the hour '0' should be '12'
//     minutes = minutes < 10 ? '0' + minutes : minutes;
//     let strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
//     return strTime;
//   };

//   return (
//     <div>
//       <div className={classes.WebcamDiv}>
//         <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
//           <h2> Current Location </h2>
//           <h3>{locData.location.replace(/_/g, ' ')}</h3>

//           {picture !== null ? (
//             <img src={picture} alt="Capture" style={{ transform: 'scaleX(-1)' }} />
//           ) : (
//             <Webcam
//               audio={false}
//               ref={webcamRef}
//               screenshotFormat="image/jpeg"
//               videoConstraints={videoConstraints}
//               style={{ width: '100%', transform: 'scaleX(-1)' }}
//             />
//           )}

//           {isSite && <input style={{ width: '100%', padding: '10px' }} onChange={handleSiteLoc} placeholder="Please Enter Location" />}
//           <div style={{ display: 'flex' }}>
//             <button onClick={capture}>{cmd}</button>
//             <button
//               onClick={() => {
//                 if (cmd === 'CheckIn') {
//                   dispatch(closeCheckIn(false));
//                 } else if (cmd === 'CheckOut') {
//                   dispatch(closeCheckOut(false));
//                 }
//                 localStorage.removeItem('Photo');
//               }}
//             >
//               Close
//             </button>
//           </div>

//           <div className={classes.DateTimeDiv}>
//             <div className={classes.Date}>
//               <h2>Date:</h2>
//               <p>
//                 {`${String(currentDate.getDate()).padStart(2, '0')} /
//                 ${currentDate.getMonth() < 10 ? '0' + parseInt(currentDate.getMonth() + 1) : currentDate.getMonth()} /
//                 ${currentDate.getFullYear()}`}
//               </p>
//             </div>

//             <div className={classes.Time}>
//               <h2>Time:</h2>
//               <p>{Time()}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CheckIn;

////////////////////////////////////////////////////////////////////////////////////////////
//  Stored the deviceId in the column of mac_id:::::::
////////////////////////////////////////////////////////////////////////////////////////////
// import React, { useState, useEffect, useRef } from 'react';
// import Webcam from 'react-webcam';
// import { useDispatch } from 'react-redux';
// import classes from './CheckIn.module.scss';
// import { checkInTime } from './../../../../Redux/action/index';
// import { closeCheckIn, closeCheckOut } from './../../../../Redux/action/interactions';
// import toast from 'react-hot-toast';
// import { v4 as uuidv4 } from 'uuid'; // Install `uuid` library

// const CheckIn = ({ loading, location, cmd }) => {
//   const videoConstraints = {
//     width: 275,
//     height: 275,
//     facingMode: 'user',
//   };

//   const dispatch = useDispatch();
//   const [locData, setLocData] = useState(location);
//   const [picture, setPicture] = useState(null);
//   const [isSite, setIsSite] = useState(false);
//   const [siteLoc, setSiteLoc] = useState('');
//   const [macId, setMacId] = useState(''); // Renamed from deviceId to macId

//   const webcamRef = useRef(null);
//   const CAMERA_DISABLED = useRef(null); 
//   const SITE_BLANK = useRef(null);

//   const currentDate = new Date();

//   useEffect(() => {
//     // Initialize Error Messages
//     if (window.env) {
//       CAMERA_DISABLED.current = window.env.ERROR.CAMERA_DISABLED;
//       SITE_BLANK.current = window.env.ERROR.SITE_BLANK;
//     } else {
//       toast.error('Problem in getting ENV File');
//     }

//     // Check Webcam Permission
//     const checkWebcamEnabled = async () => {
//       try {
//         await navigator.mediaDevices.getUserMedia({ video: true });
//       } catch (error) {
//         toast(CAMERA_DISABLED.current, { icon: '❗' });
//         dispatch(closeCheckIn(false));
//       }
//     };
//     checkWebcamEnabled();

//     if (locData.location === 'SITE') {
//       setIsSite(true);
//     }

//     // Generate or Retrieve macId
//     const storedMacId = localStorage.getItem('mac_id');
//     if (!storedMacId) {
//       const newMacId = uuidv4();
     
//       localStorage.setItem('mac_id', newMacId); // Store macId in localStorage
//       setMacId(newMacId);
//     } else {
//       setMacId(storedMacId);
//     }
//     //console.log("mac id~~~~~~",storedMacId);
//     // Auto-Reload After Timeout
//     setTimeout(() => {
//       window.location.reload(true);
//     }, 30000);
//   }, []);

//   const handleSiteLoc = (event) => {
//     setSiteLoc(event.target.value);
//   };

//   const getDeviceInfo = () => {
//     const userAgent = navigator.userAgent;
//     const isMobile = /Mobile/i.test(userAgent);

//     if (isMobile) {
//       if (/Android/i.test(userAgent)) {
//         return 'Android';
//       } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
//         return 'iOS';
//       } else {
//         return 'Mobile device of an unknown type';
//       }
//     } else {
//       return 'Desktop';
//     }
//   };

//   const capture = () => {
//     const pictureSrc = webcamRef.current.getScreenshot();

//     if (isSite && siteLoc.trim() === '') {
//       toast(SITE_BLANK.current, { icon: '❗' });
//       return;
//     }

//     sendPhotoToServer(pictureSrc.substring(23));
//     setPicture(pictureSrc);
//   };

//   const sendPhotoToServer = (imageSrc) => {
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));
//     localStorage.setItem('Photo', imageSrc);

//     dispatch(
//       checkInTime(
//         cmd.toString(),
//         userID,
//         data.empid,
//         data.token,
//         imageSrc,
//         locData.latlong,
//         locData.location,
//         locData.distance2,
//         locData.accuracy,
//         siteLoc,
//         macId // Send macId as part of payload
//       )
//     );
//   };

//   const Time = () => {
//     let hours = currentDate.getHours();
//     let minutes = currentDate.getMinutes();
//     let seconds = currentDate.getSeconds();
//     seconds = seconds < 10 ? '0' + parseInt(seconds) : seconds;
//     let ampm = hours >= 12 ? 'pm' : 'am';
//     hours = hours % 12;
//     hours = hours ? hours : 12; // the hour '0' should be '12'
//     minutes = minutes < 10 ? '0' + minutes : minutes;
//     let strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
//     return strTime;
//   };

//   return (
//     <div>
//       <div className={classes.WebcamDiv}>
//         <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
//           <h2> Current Location </h2>
//           <h3>{locData.location.replace(/_/g, ' ')}</h3>

//           {picture !== null ? (
//             <img src={picture} alt="Capture" style={{ transform: 'scaleX(-1)' }} />
//           ) : (
//             <Webcam
//               audio={false}
//               ref={webcamRef}
//               screenshotFormat="image/jpeg"
//               videoConstraints={videoConstraints}
//               style={{ width: '100%', transform: 'scaleX(-1)' }}
//             />
//           )}

//           {isSite && <input style={{ width: '100%', padding: '10px' }} onChange={handleSiteLoc} placeholder="Please Enter Location" />}
//           <div style={{ display: 'flex' }}>
//             <button onClick={capture}>{cmd}</button>
//             <button
//               onClick={() => {
//                 if (cmd === 'CheckIn') {
//                   dispatch(closeCheckIn(false));
//                 } else if (cmd === 'CheckOut') {
//                   dispatch(closeCheckOut(false));
//                 }
//                 localStorage.removeItem('Photo');
//               }}
//             >
//               Close
//             </button>
//           </div>

//           <div className={classes.DateTimeDiv}>
//             <div className={classes.Date}>
//               <h2>Date:</h2>
//               <p>
//                 {`${String(currentDate.getDate()).padStart(2, '0')} /
//                 ${currentDate.getMonth() < 10 ? '0' + parseInt(currentDate.getMonth() + 1) : currentDate.getMonth()} /
//                 ${currentDate.getFullYear()}`}
//               </p>
//             </div>

//             <div className={classes.Time}>
//               <h2>Time:</h2>
//               <p>{Time()}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CheckIn;


//////////////////////////////////////////////////////////////////////////////////////////////////////////////////
/////////////////Updated mac_id which is saved into the payload....////////////
/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { useState, useEffect, useRef } from 'react';
import Webcam from 'react-webcam';
import { useDispatch } from 'react-redux';
import classes from './CheckIn.module.scss';
import { checkInTime } from './../../../../Redux/action/index';
import { closeCheckIn, closeCheckOut } from './../../../../Redux/action/interactions';
import toast from 'react-hot-toast';
import { v4 as uuidv4 } from 'uuid'; // Install `uuid` library

const CheckIn = ({ loading, location, cmd }) => {
  const videoConstraints = {
    width: 275,
    height: 275,
    facingMode: 'user',
  };

  const dispatch = useDispatch();
  const [locData, setLocData] = useState(location);
  const [picture, setPicture] = useState(null);
  const [isSite, setIsSite] = useState(false);
  const [siteLoc, setSiteLoc] = useState('');
  const [macId, setMacId] = useState(''); // Renamed from deviceId to macId

  const webcamRef = useRef(null);
  const CAMERA_DISABLED = useRef(null); 
  const SITE_BLANK = useRef(null);

  const currentDate = new Date();

  useEffect(() => {
    // Initialize Error Messages
    if (window.env) {
      CAMERA_DISABLED.current = window.env.ERROR.CAMERA_DISABLED;
      SITE_BLANK.current = window.env.ERROR.SITE_BLANK;
    } else {
      toast.error('Problem in getting ENV File');
    }

    // Check Webcam Permission
    const checkWebcamEnabled = async () => {
      try {
        await navigator.mediaDevices.getUserMedia({ video: true });
      } catch (error) {
        toast(CAMERA_DISABLED.current, { icon: '❗' });
        dispatch(closeCheckIn(false));
      }
    };
    checkWebcamEnabled();

    if (locData.location === 'SITE') {
      setIsSite(true);
    }

    // Generate or Retrieve macId
    const storedMacId = localStorage.getItem('mac_id');
    if (!storedMacId) {
      const newMacId = uuidv4();
      localStorage.setItem('mac_id', newMacId); // Store macId in localStorage
      setMacId(newMacId);
    } else {
      setMacId(storedMacId);
    }

    // Auto-Reload After Timeout
    setTimeout(() => {
      window.location.reload(true);
    }, 300000);                         //30000
  }, []);

  const handleSiteLoc = (event) => {
    setSiteLoc(event.target.value);
  };

  const capture = () => {
    const pictureSrc = webcamRef.current.getScreenshot();

    if (isSite && siteLoc.trim() === '') {
      toast(SITE_BLANK.current, { icon: '❗' });
      return;
    }

    sendPhotoToServer(pictureSrc.substring(23));
    setPicture(pictureSrc);
  };

  const sendPhotoToServer = (imageSrc) => {
    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data'));
    localStorage.setItem('Photo', imageSrc);

    // Dispatch the action to send check-in data including macId in the payload
    dispatch(
      checkInTime(
        cmd.toString(),
        userID,
        data.empid,
        data.token,
        imageSrc,
        locData.latlong,
        locData.location,
        locData.distance2,
        locData.accuracy,
        siteLoc,
        macId // Send macId as part of the payload
      )
    );
  };

  const Time = () => {
    let hours = currentDate.getHours();
    let minutes = currentDate.getMinutes();
    let seconds = currentDate.getSeconds();
    seconds = seconds < 10 ? '0' + parseInt(seconds) : seconds;
    let ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? '0' + minutes : minutes;
    let strTime = hours + ':' + minutes + ':' + seconds + ' ' + ampm;
    return strTime;
  };

  return (
    <div>
      <div className={classes.WebcamDiv}>
        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
          <h2> Current Location </h2>
          <h3>{locData.location.replace(/_/g, ' ')}</h3>

          {picture !== null ? (
            <img src={picture} alt="Capture" style={{ transform: 'scaleX(-1)' }} />
          ) : (
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat="image/jpeg"
              videoConstraints={videoConstraints}
              style={{ width: '100%', transform: 'scaleX(-1)' }}
            />
          )}

          {isSite && <input style={{ width: '100%', padding: '10px' }} onChange={handleSiteLoc} placeholder="Please Enter Location" />}
          <div style={{ display: 'flex' }}>
            <button onClick={capture}>{cmd}</button>
            <button
              onClick={() => {
                if (cmd === 'CheckIn') {
                  dispatch(closeCheckIn(false));
                } else if (cmd === 'CheckOut') {
                  dispatch(closeCheckOut(false));
                }
                localStorage.removeItem('Photo');
              }}
            >
              Close
            </button>
          </div>

          <div className={classes.DateTimeDiv}>
            <div className={classes.Date}>
              <h2>Date:</h2>
              {/* <p>
                {`${String(currentDate.getDate()).padStart(2, '0')} /
                ${currentDate.getMonth() < 10 ? '0' + parseInt(currentDate.getMonth() + 1) : currentDate.getMonth()} / 
                ${currentDate.getFullYear()}`}
              </p> */            //////In this code months logic is wrong  that's why "Nov show 'month10' and dec show 'month11'" and jan accidently 0+1 = 1
               <p>
              {`${String(currentDate.getDate()).padStart(2, '0')} /
              ${String(currentDate.getMonth() + 1).padStart(2, '0')} /
              ${currentDate.getFullYear()}`}
              </p>
              }

              
            </div>

            <div className={classes.Time}>
              <h2>Time:</h2>
              <p>{Time()}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckIn;




















